export default function() {

    jQuery('[data-mobile-menu="hamburger"]').click(function(){

        if( jQuery(this).hasClass('is-open') ) {
            jQuery('[data-mobile-menu="main"]').addClass('is-open');
            jQuery('.overlay').addClass('is-open');
            resetMobileMenu();
        }

        jQuery('[data-mobile-menu="hamburger"]').toggleClass('is-open');
        jQuery('[data-mobile-menu="menu"]').toggleClass('is-open');
        jQuery('.overlay').toggleClass('is-open');

    });

    jQuery('.overlay').click(function(){

        jQuery('[data-mobile-menu="hamburger"]').removeClass('is-open');
        jQuery('[data-mobile-menu="menu"]').removeClass('is-open');
        jQuery('.wc__archive-filters').removeClass('is-open');
        jQuery('.wc__singleproduct-instructions').removeClass('is-open');
        jQuery('.wc__singleproduct-assembly').removeClass('is-open');
        jQuery('.overlay').removeClass('is-open');
        resetMobileMenu();

    });

    jQuery( '.drawer-menu li.has-submenu > a' ).click(function(){

        let val = jQuery(this).find('.categorie').text().trim();
        let depth = jQuery(this).find('.categorie').data('id');

        jQuery('.categorie-' + depth ).text( val );
        jQuery('.drawer-menu-mobile-nav').removeClass('is-open');

        if ( jQuery(this).parents('.has-submenu').length > 1 ) {
            jQuery(this).parents('.drawer-menu-sub').css( 'transform', 'translateX(-100%)' );

        } else {
            jQuery('.drawer-menu-sub').css( 'transform', 'translateX(100%)' );
        }

        jQuery(this).next( '.drawer-menu-sub' ).css( 'transform', 'translateX(0)' );

    });

    jQuery( '.drawer-menu-return' ).click(function(){

        jQuery(this).parent('.drawer-menu-sub').css( 'transform', 'translateX(100%)' );

        if ( jQuery(this).parents('.drawer-menu-sub').length > 1 ) {
            jQuery(this).parents('.drawer-menu-sub').eq(1).css( 'transform', 'translateX(0)' ); // Not itself, but ancestor sub.
        } else {
            jQuery('.drawer-menu-mobile-nav').addClass('is-open');
        }

    });

    function resetMobileMenu() {

        jQuery('.drawer-menu-mobile-nav').addClass('is-open');
        jQuery( '.drawer-menu-sub' ).css( 'transform', 'translateX(0)' );

    }

}